var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-2" }, [
    _c("div", { staticClass: "col-4" }, [_vm._t("label")], 2),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-8" },
      [
        _vm.hasIcon
          ? _c(
              "input-group",
              { attrs: { icon: _vm.icon } },
              [_vm._t("input")],
              2
            )
          : _vm._t("input")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }